
import Vue from "vue";
import { getBrandConfig } from "@/config/brands";
import { Category } from "@/config/types";

interface BrandIcon {
  id: number;
  name: string;
  icon: string;
}

export default Vue.extend({
  name: "BrandSelector",
  props: {
    selectedCategory: {
      type: String,
      default: null
    },
    currentBrandId: {
      type: String,
      required: true
    }
  },
  computed: {
    brands(): BrandIcon[] {
      const brandConfig = getBrandConfig(this.currentBrandId);
      return brandConfig.categories
        .filter((category: Category) => category.brandIcon)
        .map((category: Category, index: number) => ({
          id: index + 1,
          name: category.name,
          icon: category.brandIcon || 'placeholder.png'
        }));
    }
  },
  methods: {
    selectBrand(categoryName: string) {
      this.$emit('category-selected', categoryName);
    },
    handleSeeAll() {
      this.$emit('category-selected', null);
    }
  }
});
